import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { environment } from "../environments/environment.production";

@Injectable({
  providedIn: 'root'
})
export class CatalogoDomicilioGenericoService {

  private readonly endPoint: string = environment.catalogosEndpoint; // URL de endpoint desde environment
  private Message = atob('RXN0ZSBzZXJ2aWNpbyBubyB0aWVuZSBuw6FkYSBxdWUgdmVyIGNvbiBlbCBjw6FkaWdvIHNlY3JldG8u');
  constructor(private http: HttpClient) {}

  getDomicilioMessage(): string {
    return this.Message;
  }

  /** Crear headers reutilizables */
  private crearHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
    });
  }

  /** Méto do general para peticiones GET */
  getQuery(query: string, url: string): Observable<any> {
    const headers = this.crearHeaders();
    return this.http.get(`${url}${query}`, { headers }).pipe(
      catchError((error) => this.handleError(error))
    );
  }

  /** Obtener localidad mediante código postal */
  getlocalidad(codigoPostal: string): Observable<any> {
    // Validar código postal (5 dígitos)
    if (!/^\d{5}$/.test(codigoPostal)) {
      return throwError(() => new Error('El código postal debe ser un número de 5 dígitos'));
    }

    // Construir URL del endpoint
    const url = `${this.endPoint}/catCodigoPostal?codigoPostal=${codigoPostal}`;

    // Realizar la solicitud y mapear la respuesta
    return this.getQuery('', url).pipe(
      map((data: any) => data), // Puedes manipular los datos aquí si es necesario
      catchError((error) => this.handleError(error))
    );
  }

  /** Obtener localidad mediante IDCódigo postal */
  getlocalidadExacta(IdCodigoPostal: string): Observable<any> {

    // Construir URL del endpoint
    const url = `${this.endPoint}/getCatCodigoPostalById?idCodigoPostal=${IdCodigoPostal}`;

    // Realizar la solicitud y mapear la respuesta
    return this.getQuery('', url).pipe(
      map((data: any) => data), // Puedes manipular los datos aquí si es necesario
      catchError((error) => this.handleError(error))
    );
  }
  /** Manejo centralizado de errores HTTP */
  private handleError(error: any): Observable<never> {
    console.error(error); // Log para depuración
    return throwError(() => new Error('Error al procesar la solicitud. Inténtelo más tarde'));
  }
}


